import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UpdateExternalToolDto } from '@inference.engine/api-client/web';
import { notificationService } from '@/lib/services/notification.service';
import { i18n } from '@/shared/i18n';
import { logger } from '@/lib/utils/logger';
import { updateExternalTool } from '../api';
import { EXTERNAL_TOOLS_QUERY_KEY } from './queryKeys';

export const useUpdateExternalTool = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      body,
      workspaceId,
    }: {
      id: string;
      body: UpdateExternalToolDto;
      workspaceId?: string;
    }) => {
      return updateExternalTool(id, body, workspaceId);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [EXTERNAL_TOOLS_QUERY_KEY] });
      notificationService.showSuccess(
        i18n.t('admin:externalTool.useUpdateExternalTool.externalToolUpdatedSuccessfully'),
      );
    },
    onError: (error) => {
      notificationService.showError(
        i18n.t('admin:externalTool.useUpdateExternalTool.failedToUpdateExternalTool'),
      );
      logger.error('Failed to update external tool:', error);
    },
  });
};
